import { ApiGetResponse, ApiRequest } from 'app/common/types'
import { ConnectionName, InstalledConnection } from 'app/connections/types'

interface DatePeriodGetContent {
  fromDate: string
  toDate: string
}

type TotalsPerConnection = Record<ConnectionName, number>

interface MatchingRateEntity {
  cookiesPerConnection: TotalsPerConnection
  date: string
  profilesWithCookies: number
}

export type MatchingRateGetRequest = ApiRequest<DatePeriodGetContent>
export type MatchingRateResponse = ApiGetResponse<MatchingRateEntity[]>

export type MatchingRate = Record<string, number>

type CookieCounts = {
  total: number
  totalPerConnection: TotalsPerConnection
}

export const mapToMatchingRate = (
  matchingRateEntities: MatchingRateEntity[],
  connections: InstalledConnection[],
): MatchingRate => {
  const initialCookieCounts: CookieCounts = {
    total: 0,
    totalPerConnection: connections.reduce((acc, conn) => {
      acc[conn.name] = 0
      return acc
    }, {} as TotalsPerConnection),
  }

  const cookieCounts = matchingRateEntities.reduce((acc, conversionEntity) => {
    acc.total += conversionEntity.profilesWithCookies

    Object.entries(conversionEntity.cookiesPerConnection).forEach(([connectionName, count]) => {
      if (acc.totalPerConnection[connectionName as ConnectionName]) {
        acc.totalPerConnection[connectionName as ConnectionName] += count
      } else {
        acc.totalPerConnection[connectionName as ConnectionName] = count
      }
    })

    return acc
  }, initialCookieCounts)

  return Object.entries(cookieCounts.totalPerConnection).reduce((acc, [connectionName, count]) => {
    acc[connectionName] = cookieCounts.total ? count / cookieCounts.total : 0
    return acc
  }, {} as MatchingRate)
}
